<div class="overlay" *ngIf="isLoading | async">
  <div class="spinner">
    <div class="spinner-part spinner-part1"></div>
    <div class="spinner-part spinner-part2"></div>
    <img src="/assets/images/motorbike.png" alt="Suzuki Bike" class="spinner-center">
  </div>
</div>
<h2 mat-dialog-title>
  Non Sales
  <img class="close-button"  (click)="onNoClick()" src="/assets/images/close.png" alt="">
</h2>
<mat-dialog-content>
    <form class="non-sales" [formGroup]="nonsalesForm" >
      <div class="form-content">
    <div class="mb-3">
      <label for="category" class="form-label">Category<span class="alert-small">*</span></label>
       <select id="category" formControlName="category" class="form-select" (change)="onCategoryChange($event)" [attr.value]="nonsalesForm.get('category')?.value"
      [ngClass]="{ 'is-invalid': submitted && f['category'].errors }">
        <option disabled selected value="">Select</option>
       <option *ngFor="let category of nonSalesCategories" [value]="category.id + ':' + category.category"> <span>{{ category.category }}</span></option>
      </select>
      <div  *ngIf="submitted && f['category'].errors" class="invalid-feedback">
        <div *ngIf="nonsalesForm.get('category')?.errors?.['required']" class="error-msg">
            Please Select Category.
        </div>
    </div>
    </div>
    <div class="mb-3" *ngIf="isServiceSelected || nonsalesForm.get('category')?.value == '1:Service Booking'">
      <label for="registration_number" class="form-label">Registration Number<span class="alert-small">*</span></label>
      <!-- <input type="text" class="form-control" id="registration_number" formControlName="registration_number" placeholder="Enter Registration Number"> -->
      <input 
      type="text" 
      class="form-control" 
      id="registration_number" 
      formControlName="registration_number"
      placeholder="Enter Registration Number" 
      [ngClass]="{ 'is-invalid': submitted && f['registration_number'].errors }"
    />
    <div  *ngIf="submitted && f['registration_number'].errors" class="invalid-feedback">
      <div *ngIf="nonsalesForm.get('registration_number')?.errors?.['required']" class="error-msg">
          Please Enter Registration Number.
      </div>
  </div>
    </div>
    <div class="mb-3">
      <label for="remarks" class="form-label">Remarks</label>
      <textarea class="form-control" id="remarks" formControlName="remarks" rows="3" [attr.value]="nonsalesForm.get('remarks')?.value" placeholder="Enter Text here"></textarea>
    </div>
  </div>
   
  </form>
</mat-dialog-content>
<mat-dialog-actions class="d-flex justify-content-end">
  <button class="btn white-btn mr-2" (click)="onNoClick()">Cancel</button>
  <button *ngIf="!isUpdate" class="btn blue-btn mr-3" (click)="onSubmit()">Submit</button>
  <button *ngIf="isUpdate" class="btn blue-btn mr-3" (click)="onUpdate()">Submit</button>
</mat-dialog-actions>
